import { authorizedApiClient } from "./config";

export type MeetingAutomationPreferences = {
  id: string;
  workspace_id: string;
  workspace_member_id?: string | null;

  // Pre-meeting settings
  pre_meeting_enabled: boolean;
  pre_meeting_minutes_before: number;
  pre_meeting_notify_channel: string;
  pre_meeting_slack_channel_id?: string | null;
  pre_meeting_include_internal: boolean;
  pre_meeting_guidance?: string | null;

  // Post-meeting summary settings
  post_meeting_summary_enabled: boolean;
  post_meeting_summary_channel: string;
  post_meeting_summary_slack_channel_id?: string | null;

  // Post-meeting followup settings
  post_meeting_followup_enabled: boolean;
  post_meeting_followup_channel: string;
  post_meeting_followup_slack_channel_id?: string | null;
  post_meeting_include_internal: boolean;
  post_meeting_guidance?: string | null;

  // Custom skill overrides
  pre_meeting_custom_skill_id?: string | null;
  post_meeting_summary_custom_skill_id?: string | null;
  post_meeting_followup_custom_skill_id?: string | null;

  created_at?: string | null;
  updated_at?: string | null;
};

export type MeetingAutomationPreferencesUpdate = {
  pre_meeting_enabled?: boolean;
  pre_meeting_minutes_before?: number;
  pre_meeting_notify_channel?: string;
  pre_meeting_slack_channel_id?: string | null;
  pre_meeting_include_internal?: boolean;
  pre_meeting_guidance?: string | null;

  post_meeting_summary_enabled?: boolean;
  post_meeting_summary_channel?: string;
  post_meeting_summary_slack_channel_id?: string | null;

  post_meeting_followup_enabled?: boolean;
  post_meeting_followup_channel?: string;
  post_meeting_followup_slack_channel_id?: string | null;
  post_meeting_include_internal?: boolean;
  post_meeting_guidance?: string | null;

  pre_meeting_custom_skill_id?: string | null;
  post_meeting_summary_custom_skill_id?: string | null;
  post_meeting_followup_custom_skill_id?: string | null;
};

export const getMeetingAutomationPreferences = async (params: {
  workspace_id: string;
  workspace_member_id?: string;
}) => {
  const response = await authorizedApiClient.get<MeetingAutomationPreferences>(
    `/meeting-automation/${params.workspace_id}/preferences/meeting-automation`,
    {
      params: params.workspace_member_id
        ? { workspace_member_id: params.workspace_member_id }
        : undefined,
    },
  );
  return response.data;
};

export type AvailableSkill = {
  id: string | null;
  name: string;
  display_name: string;
  kind: string;
  is_default: boolean;
};

export const getAvailableSkills = async (params: {
  workspace_id: string;
}): Promise<AvailableSkill[]> => {
  const response = await authorizedApiClient.get<AvailableSkill[]>(
    `/meeting-automation/${params.workspace_id}/preferences/meeting-automation/available-skills`,
  );
  return response.data;
};

export const updateMeetingAutomationPreferences = async (params: {
  workspace_id: string;
  preferences: MeetingAutomationPreferencesUpdate;
  workspace_member_id?: string;
}) => {
  const response = await authorizedApiClient.put<MeetingAutomationPreferences>(
    `/meeting-automation/${params.workspace_id}/preferences/meeting-automation`,
    params.preferences,
    {
      params: params.workspace_member_id
        ? { workspace_member_id: params.workspace_member_id }
        : undefined,
    },
  );
  return response.data;
};
